<template>
  <div>
    <v-container>
      <div>
        <v-layout row wrap>
          <v-flex xs2>
            <div class="form-control" style="position: relative">
              <div class="labelinputontop">Start date</div>
              <DatePickerWithoutButton v-model="selectedDate.start" @change="onChangeDate">
                <input readonly :value="DateFormat(selectedDate.start)" type="text" />
              </DatePickerWithoutButton>
            </div>
          </v-flex>
          <v-flex xs2 class="pl-2">
            <div class="form-control" style="position: relative">
              <div class="labelinputontop">End date</div>
              <DatePickerWithoutButton v-model="selectedDate.end" @change="onChangeDate">
                <input readonly :value="DateFormat(selectedDate.end)" type="text" />
              </DatePickerWithoutButton>
            </div>
          </v-flex>
          <v-flex xs8 class="text-sm-right">
            <template v-if="loading">
              <v-btn :loading="true" color="grey" outline class="ma-0 mb-1"></v-btn>
            </template>
            <template v-else>
              <exportxlsx :promised-value="getXlsxData"></exportxlsx>
            </template>
          </v-flex>
        </v-layout>
      </div>
      <div>
        <v-layout row wrap>
          <v-flex xs6>
            <div class="primary--text" style="font-weight: bold; font-size: 20px">
              Ticketing performance
            </div>
          </v-flex>
          <v-flex xs3>
            <multiselect
              v-model="selectedGroup"
              :loading="loading"
              label="groupname"
              :show-labels="false"
              :allow-empty="false"
              placeholder="select group"
              :options="agentGroups"
              @input="onChangeGroup"
            ></multiselect>
          </v-flex>
          <v-flex xs3 class="pl-1">
            <multiselect
              v-model="selectedSubGroup"
              :loading="loading"
              label="subgroupname"
              :show-labels="false"
              :allow-empty="false"
              placeholder="select group"
              :options="agentSubGroup"
              @input="onChangeSubGroup"
            ></multiselect>
          </v-flex>
        </v-layout>

        <div>
          <v-data-table
            :loading="loading"
            :headers="headers"
            :items="data"
            class="elevation-1"
            :pagination.sync="pagination"
            hide-actions
          >
            <template #items="props">
              <tr style="cursor: pointer" @click="showDialog(props.item)">
                <td>
                  {{ props.item.name }}
                </td>
                <td>
                  {{ props.item.answered }}
                </td>
                <td>
                  {{ props.item.pending }}
                </td>
                <td>
                  {{ props.item.closed }}
                </td>
                <td v-if="['126654220708334', '108971401389284'].includes(selectedBot.pageid)">
                  {{ props.item.cold_case }}
                </td>
                <td>
                  {{ props.item.transfer }}
                </td>
                <td>
                  {{
                    props.item.firsttime && props.item.totalFirstResponseTicket
                      ? formatAvg(props.item.firsttime / props.item.totalFirstResponseTicket)
                      : formatAvg(0)
                  }}
                </td>
                <td>
                  {{
                    props.item.closetime && props.item.closed
                      ? formatAvg(props.item.closetime / props.item.closed)
                      : formatAvg(0)
                  }}
                </td>
              </tr>
            </template>
          </v-data-table>
        </div>
      </div>
      <v-dialog v-model="dialog" width="800px" persistent>
        <v-card v-if="dialog">
          <dialog-agent
            :dialogdata="dialogdata"
            :selected-date="selectedDate"
            @close="dialog = false"
          ></dialog-agent>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>

<script>
import DatePickerWithoutButton from '@/components/elements/DatePickerWithoutButton.vue'
import multiselect from 'vue-multiselect'
import moment from 'moment'
import api from '@/api'
import { mapGetters } from 'vuex'
import DialogAgent from './DialogAgent.vue'
import exportxlsx from '@/components/elements/exportxlsx.vue'

export default {
  components: {
    DatePickerWithoutButton,
    DialogAgent,
    multiselect,
    exportxlsx
  },
  computed: {
    agentGroups() {
      if (this.getAgentGroup && this.getAgentGroup.length) {
        return [{ groupname: 'All', id: '' }, ...this.getAgentGroup]
      }
      return [{ groupname: 'All', id: '' }]
    },
    ...mapGetters(['selectedBot', 'getAgentGroup', 'getAgentSubgroup']),
    com7pageid() {
      let pageid =
        selectedBot.theme === 'ustore' ? selectedBot.pageid : this.$store.state.com7pages[0].pageid
      return pageid
    },
    agentSubGroup() {
      if (this.selectedGroup && this.getAgentSubgroup && this.getAgentSubgroup.length) {
        let subgroups = this.getAgentSubgroup.filter(
          (el) => el.admingroupid == this.selectedGroup.id
        )
        return [{ subgroupname: 'All', id: '' }, ...subgroups]
      }
      return [{ subgroupname: 'All', id: '' }]
    }
  },
  data() {
    return {
      data: [],
      selectedGroup: { groupname: 'All', id: '' },
      selectedSubGroup: { subgroupname: 'All', id: '' },
      dialog: false,
      dialogdata: '',
      loading: false,
      pagination: { rowsPerPage: -1, sortBy: '' },
      headers: [
        { text: 'Agent', value: 'agent' },
        { text: 'Answered', value: 'Answered' },
        { text: 'Pending', value: 'Pending' },
        { text: 'Closed', value: 'Closed' },
        { text: 'Tickets transfer', value: 'Tickets transfer' },
        // { text: 'Tickets reassigned', value: 'Tickets reassigned' },
        { text: 'Average 1st response time', value: 'Average 1st response time' },
        { text: 'Average resolved ticket time', value: 'Average resolved ticket time' }
      ],
      selectedDate: {
        start: moment().format('YYYY-MM-DD'),
        end: moment().format('YYYY-MM-DD')
      }
    }
  },
  mounted() {
    if (['126654220708334', '108971401389284'].includes(this.selectedBot.pageid)) {
      let item = [{ text: 'Cold case', value: 'Cold case' }]
      this.headers.splice(4, 0, ...item)
    }

    this.getData()

    this.selectedGroup = this.getAgentGroup.find((el) => el.groupname == 'Agent')
  },
  methods: {
    onChangeGroup() {
      this.selectedSubGroup = { subgroupname: 'All', id: '' }
      this.getData()
    },
    onChangeSubGroup() {
      this.getData()
    },
    formatAvg(secs) {
      const formatted = moment.utc(parseInt(secs) * 1000).format('H ชั่วโมง m นาที s วินาที')
      return formatted
    },
    getData() {
      var data = {
        pageid: this.selectedBot.pageid,
        startTime: this.selectedDate.start, // YYYY-MM-DD
        endTime: this.selectedDate.end // YYYY-MM-DD
      }
      if (this.selectedGroup && this.selectedGroup.id) {
        Object.assign(data, { adminGroupId: this.selectedGroup.id })
      }
      if (this.selectedSubGroup && this.selectedSubGroup.id) {
        data.adminSubGroupId = this.selectedSubGroup.id
      }
      this.loading = true
      api.ticket2CommonTicketByAgentWithWorkingHour(data, (err, response) => {
        var result = []
        result = this.calculateTicket(response.data)
        this.data = result
        this.loading = false
      })
    },
    getXlsxData() {
      return new Promise(async (resolve) => {
        await this.getData()
        var data = this.data

        resolve(
          data.map((el) => {
            return {
              Agent: el.name,
              Answered: el.answered,
              Pending: el.pending,
              Closed: el.closed,
              'Cold case': el.cold_case,
              'Ticket transfer': el.transfer,
              'Average 1st response time': this.formatAvg(el.firsttime / el.totalticket),
              'Average resolved ticket time': this.formatAvg(el.closetime / el.totalticket)
            }
          })
        )
      })
    },
    showDialog(item) {
      this.dialogdata = item.adminid
      this.dialog = true
    },

    calculateTicket(data) {
      var list = {}
      var agents = []
      data.map((el) => {
        if (list.hasOwnProperty(el.adminid)) {
          list[el.adminid].transfer += parseInt(el.transferticket)
          list[el.adminid].firsttime += parseInt(el.firsttime)
          list[el.adminid].closetime += parseInt(el.closetime)
          list[el.adminid].cold_case += parseInt(el.cold_case)
          list[el.adminid].totalticket += 1
          list[el.adminid].totalFirstResponseTicket += parseInt(el.amount)
          list[el.adminid].all += parseInt(el.amount)
          switch (el.status) {
            case 'pending':
              list[el.adminid].pending += parseInt(el.amount)
              break
            case 'answered':
              list[el.adminid].answered += parseInt(el.amount)
              break
            case 'closed':
              list[el.adminid].closed += parseInt(el.amount)
              list[el.adminid].averageclosetime = (
                parseFloat(el.closetime) / parseFloat(el.amount)
              ).toFixed(2)
              break
            case 'cancelled':
              list[el.adminid].cancelled += parseInt(el.amount)
              break
            case 'cancelled by customer':
              list[el.adminid].cancelledbycustomer += parseInt(el.amount)
              break

            default:
              break
          }
        } else {
          list[el.adminid] = {
            adminid: el.adminid,
            name: el.name,
            all: parseInt(el.amount),
            pending: 0,
            closed: 0,
            cold_case: 0,
            answered: 0,
            cancelled: 0,
            cancelledbycustomer: 0,
            averageclosetime: 0,
            transfer: 0,
            firsttime: 0,
            closetime: 0,
            totalticket: 0,
            totalFirstResponseTicket: 0
          }
          list[el.adminid].transfer += parseInt(el.transferticket)
          list[el.adminid].firsttime += parseInt(el.firsttime)
          list[el.adminid].closetime += parseInt(el.closetime)
          list[el.adminid].cold_case += parseInt(el.cold_case)
          list[el.adminid].totalticket += 1
          list[el.adminid].totalFirstResponseTicket += parseInt(el.amount)

          switch (el.status) {
            case 'pending':
              list[el.adminid].pending += parseInt(el.amount)
              break
            case 'closed':
              list[el.adminid].closed += parseInt(el.amount)
              list[el.adminid].averageclosetime = (
                parseFloat(el.closetime) / parseFloat(el.amount)
              ).toFixed(2)
              break
            case 'answered':
              list[el.adminid].answered += parseInt(el.amount)
              break
            case 'cancelled':
              list[el.adminid].cancelled += parseInt(el.amount)
              break
            case 'cancelled by customer':
              list[el.adminid].cancelledbycustomer += parseInt(el.amount)
              break

            default:
              break
          }
        }
      })

      for (const key in list) {
        if (list.hasOwnProperty(key)) {
          const element = list[key]
          agents.push(element)
        }
      }

      return agents
    },
    onChangeDate() {
      this.getData()
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/cityfresh/agentmanagement/Agentperformance.vue